import { years } from '@/utils/date';
import { useQueries } from '@tanstack/react-query';
import { getActivities } from './useActivities';
import { useGetAccessToken } from './useGetAccessToken';

type Years = typeof years;

const staleTime = 10 * 60 * 1000; // 10 minutes

export const useParallelActivities = (years: Years) => {
  const { access_token } = useGetAccessToken();
  return useQueries({
    queries: years.map((year) => {
      return {
        queryKey: [`activities ${year}`],
        queryFn: () => getActivities(access_token || '', year),
        staleTime,
        enabled: access_token !== undefined,
      };
    }),
  });
};
